import React from 'react';
import { observer } from 'mobx-react';
import { PodcastStore } from '@seedlang/stores';
import { AppUI } from '@seedlang/state';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class PodcastCreate extends React.Component {

  onCreate = title => {
    const data = {
      title,
      siteId: AppUI.site.id,
    };
    PodcastStore.create({data}, this.props.afterCreate);
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a title'
        onCreate={this.onCreate}
      />
    );
  }
}

export default PodcastCreate;
